import React, { Component } from "react";

import { withRouter } from "react-router-dom";

import { Card, CardBody, TabContent, TabPane, Nav, NavItem, NavLink, Button, Spinner, Row, Col } from "reactstrap";
import classnames from "classnames";
import GeneralEditMealPlanForm from "./GeneralEditMealPlan";
import EditRoasterPlanForm from "./EditRoasterPlanForm";
import { draftMealPlanService } from "./service/drafMealPlan.service";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../Shared/ConfirmationModal";

class EditMealPlanManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
            submitted: false,
            submitting: false,
            dailySubmitted: false,
            dailySubmitting: false,
            formResponse: null,
            formError: null,
            totalDays: 0,
            daysLeft: 0,
            days: 0,
            mealPlanId: null,
            mealPlanName: null,
            mealPlanDescription: null,
            mealPlanCalorie: null,
            mealRoasterFormModal: false,
            mealImageUrl: null,
            generalFormSubmitting: false,
            generalFormSubmtted: false,
            generalFormError: null,
            roasterFormError: null,
            roasterResponseData: null,
            roasterHideFormCss: false,
            //for submit button
            approvalSubmitting: false,
            showModal: false,
            mealStatus: null,
            reviewerRemarks: null,
            submitToAdminError:null
        };
    }
    getRoasterData = async (id) => {
        this.setState({
            roasterFormError: null,
        });
        try {
            let response = await draftMealPlanService.getDailyMealRoaster(id);
            if (response) {
                
                this.setState({
                    roasterResponseData: response && response.data,
                });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                roasterFormError: error,
            });
        }
    };
    updateGeneralForm = async (data, id) => {
        this.setState({
            ...this.state,
            generalFormSubmitting: true,
            generalFormSubmtted: false,
            generalFormError: null,
            mealRoasterFormModal: true,
        });
        try {
            let response = await draftMealPlanService.updateGeneralMealPlan(data, id);
            if (response) {
                toast.success("Meal Plan Updated successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.setState({
                    days: response.data.durationDays,
                    mealPlanId: response.data.id,
                    mealPlanName: response.data.name,
                    mealPlanDescription: response.data.description,
                    mealPlanCalorie: response.data.calories,
                    mealImageUrl: response.data.imageUrl,
                    mealRoasterFormModal: false,
                    generalFormSubmitting: false,
                    generalFormSubmtted: false,
                    generalFormError: null,
                });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                generalFormError: error,
                generalFormSubmitting: false,
                mealRoasterFormModal: false,
            });
        }
    };
    updateDailyMealPlan = async (data) => {
        const { mealPlanId } = this.state;
        let day = data ? data.day : 1;
        this.setState({
            ...this.state,
            dailySubmitting: true,
            dailySubmitted: false,
            roasterFormError: null,
        });
        try {
            let response = await draftMealPlanService.updateMealRoaster(data, mealPlanId);
            if (response) {
                toast.success(`Day ${day} Meal Plan updated successfully`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
               

                this.setState({
                    ...this.state,
                    dailySubmitting: false,
                    dailySubmitted: true,
                    roasterFormError: null,
                    roasterHideFormCss: true,
                });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                roasterFormError: error,
                dailySubmitting: false,
                roasterHideFormCss: true,
            });
        }
    };
    sentToAdminForApproval = async () => {
        const { mealPlanId } = this.state;
        this.setState({
            ...this.state,
            submitToAdminError: null,
            approvalSubmitting: true,
        });
        try {
            let response = await draftMealPlanService.sendForApproval(mealPlanId);

            if (response == null) {
                toast.success(` Meal Plan sent successfully`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.setState({
                    approvalSubmitting: false,
                });
                this.routeChange();
            }
        } catch (error) {
            this.setState({
                ...this.state,
                submitToAdminError: error,
                approvalSubmitting: false,
            });
        }
    };
    routeChange = () => {
        this.props.history.push({
            pathname: `/meal-plan-drafts`,
        });
    };

    componentDidMount() {
        if (this.props && this.props.location) {
            const { mealData } = this.props.location.state;
       
            this.setState(
                {
                    days: mealData.durationDays,
                    mealPlanId: mealData.id,
                    mealPlanName: mealData.name,
                    mealPlanDescription: mealData.description,
                    mealPlanCalorie: mealData.calories,
                    mealImageUrl: mealData.imageUrl,
                    mealStatus: mealData.status,
                    reviewerRemarks: mealData.reviewerRemarks,
                },
                () => this.getRoasterData(this.state.mealPlanId)
            );
        }
    }

    handleSubmit = (data) => {
        try {
            if (this.state.mealPlanId) {
                this.updateGeneralForm(data, this.state.mealPlanId);
            }
        } catch (e) {
            console.error(e);
        }
    };
    updateDailyMealRoaster = (data, day) => {
        try {
            if (this.state.mealPlanId) {
                this.updateDailyMealPlan(data, day);
            }
        } catch (e) {
            console.error(e);
        }
    };

    deleteDailyRoaster = async (id) => {
        const { mealPlanId } = this.state;
        this.setState({
            ...this.state,
            generalFormError: null,
            mealRoasterFormModal: true,
        });
        try {
            let response = await draftMealPlanService.deleteDailyMealRoaster(id);

            if (response === null) {
                toast.success(` Meal Roaster deleted successfully`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
                this.setState(
                    {
                        ...this.state,
                        generalFormError: null,
                        mealRoasterFormModal: false,
                    },
                    () => this.getRoasterData(mealPlanId)
                );
            }
        } catch (error) {
            this.setState({
                ...this.state,
                generalFormError: error,
                mealRoasterFormModal: false,
            });
        }
    };

    submitMealPlan = () => {
        const { mealPlanId } = this.state;

        if (mealPlanId) {
            this.sentToAdminForApproval();
        }
    };
    showDeleteModal = (id) => {
        this.deleteDailyRoaster(id);
    };
    hideMealRoasterForm = () => {
        this.setState({ mealRoasterFormModal: false });
    };

    showMealRoasterForm = () => {
        this.setState({ mealRoasterFormModal: true });
    };
    resetRoasterFormCss = () => {
        this.setState({ roasterHideFormCss: false });
    };
    cancel = () => {
        this.setState({ mealImageUrl: null });
    };
    showConfirmation = () => {
        this.setState({
            showModal: !this.state.showModal,
            submitToAdminError:null,
            approvalSubmitting:false

        });
    };
    render() {
        const {
            activeTab,
            submitted,
            submitting,
            formError,
            mealPlanId,
            totalDays,
            dailySubmitted,
            dailySubmitting,
            mealPlanName,
            mealPlanDescription,
            mealPlanCalorie,
            mealImageUrl,
            days,
            generalFormSubmtted,
            generalFormSubmitting,
            generalFormError,
            //state for roaster
            mealRoasterFormModal,
            roasterResponseData,
            roasterFormError,
            roasterHideFormCss,
            //approval button state
            approvalSubmitting,
            mealStatus,
            reviewerRemarks,
            submitToAdminError,
            
        } = this.state;
        let generalMealPlanDatas = {
            mealPlanId,
            mealPlanName,
            mealPlanDescription,
            mealPlanCalorie,
            days,
        };
        let spinnerSubmitToAdmin = {
            sending:approvalSubmitting ? true:false,
        };
        return (
            <div>
                <Card>
                    <CardBody>
                        <GeneralEditMealPlanForm
                            generalMealPlanDatas={generalMealPlanDatas}
                            hideMealRoasterForm={this.hideMealRoasterForm}
                            mealImageUrl={mealImageUrl}
                            cancel={this.cancel}
                            showMealRoasterForm={this.showMealRoasterForm}
                            handleSubmit={this.handleSubmit}
                            submitted={generalFormSubmtted}
                            submitting={generalFormSubmitting}
                            formError={generalFormError}
                            roasterResponseData={roasterResponseData}
                        />
                        <EditRoasterPlanForm
                            mealRoasterFormModal={mealRoasterFormModal}
                            totalNumDays={days}
                            responseRoaster={roasterResponseData ? roasterResponseData : null}
                            updateDailyMealRoaster={this.updateDailyMealRoaster}
                            submitted={dailySubmitted}
                            submitting={dailySubmitting}
                            formError={roasterFormError}
                            roasterHideFormCss={roasterHideFormCss}
                            resetRoasterFormCss={this.resetRoasterFormCss}
                            showDeleteModal={this.showDeleteModal}
                            status={mealStatus}
                            reviewerRemarks={reviewerRemarks}
                        />
                        {
                            <Row style={{ marginTop: "1rem" }}>
                                <Col sm="12" md={{ size: 6, offset: mealStatus === "DECLINED" ? 2 : 3 }}>
                                    <Button type="button" color="primary" onClick={this.showConfirmation} style={{ marginLeft: "10rem" }}>
                                        {approvalSubmitting? <Spinner size="sm" /> : <span>{"Submit for approval"}</span>}
                                    </Button>
                                </Col>
                            </Row>
                        }
                        {<ConfirmationModal isOpen={this.state.showModal} showModal={this.showConfirmation} action={this.submitMealPlan} message={"Do you want to submit your meal plan for approval ?"} 
                        actionState={ spinnerSubmitToAdmin} 
                               mealPlanError={submitToAdminError}
                             
                        />}
                     
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withRouter(EditMealPlanManager);
